import React, { Component } from "react";
import "./ImageEditor.css";
import "tui-image-editor/dist/tui-image-editor.css";
import ToastUiImageEditor from "tui-image-editor";
// import TuiImageEditor from '@toast-ui/react-image-editor';
import { FormGroup, Label, Input, Button, Form } from "reactstrap";
import Axios from "axios";
import { configuration } from "../../appConfig";
import RequestLoader from "../../spinner";

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class ImageEditor extends Component {
  constructor(props) {
    super(props);

    this.initialState = {
      imageLoadingError: this.props.imageUrl === '' ? true : false,
      loading: true,
      data: '',
      prepopulatePartOfDamage: "",
      prePopulatePartName: window.location.pathname.split("/")[2],
      prepopulateComment: "",
      type_of_damage: "",
      size_of_damage: "",
      comment: "",
      damage_part_name: "",
      words: "",
      lang: localStorage.getItem('lang'),
      toggle_next_btn_loader: false,
      toggle_finish_btn_loader: false,
    };
    this.state = this.initialState;
  }

  componentDidMount(){
    if(this.props.prepopulate){
      this.setState({ loading:true })
      const partnerId = localStorage.getItem("partnerId");
      const vin = localStorage.getItem("selectedFile");
      Axios.get(
        `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
      ).then((r) => {
        //  console.table(r.data.Dents[0].DentPos);
        if (r.data) {
          this.setState({ data: r.data })
        }
        this.setState({
          loading: false
        })
      }).catch(error=>this.setState({ loading: false }));
      this.getLang()
    }
  }
  loadImageContent = () => {
    var imageEditorCanvas = document.getElementsByClassName("lower-canvas");
    var base64image = imageEditorCanvas[0].toDataURL("image/jpeg", 1.0);
    // var instance = imageEditorCanvas.current.getInstance();
    // var data = this.state;

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const {
      type_of_damage,
      size_of_damage,
      comment,
      damage_part_name: partName,
    } = this.state;
    return Axios.post(configuration.uploadExtraScanListRecords, {
      partnerId,
      base64image,
      vin,
      comment,
      partName,
      damageSize: size_of_damage,
      damageType: type_of_damage,
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };

  lang = (word) => {
    const lang = localStorage.getItem('lang')
    const { words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  onNextClick = () => {
    this.setState({ toggle_next_btn_loader: true });
    this.loadImageContent()
      .then((res) => {
        if (!res.data.success) {
          var error_msg = "";
          if (typeof res.data.validation_errors === "object") {
            Object.keys(res.data.validation_errors).map(
              (obj_key) =>
                (error_msg += `${res.data.validation_errors[obj_key]} `)
            );
            error_msg = error_msg.trim();
          }
          alert(error_msg || "Error occurred!!");
        } else {
          this.setState(this.initialState);
          window.location.reload();
        }
      })
      .catch((err) => {
        alert("Error occurred!!");
      })
      .finally(() => {
        this.setState({ toggle_next_btn_loader: false });
      });
  };

  onFinishClick = () => {
    this.setState({ toggle_finish_btn_loader: true });
    this.loadImageContent()
      .then((res) => {
        if (!res.data.success) {
          var error_msg = "";
          if (typeof res.data.validation_errors === "object") {
            Object.keys(res.data.validation_errors).map(
              (obj_key) =>
                (error_msg += `${res.data.validation_errors[obj_key]} `)
            );
            error_msg = error_msg.trim();
          }
          alert(error_msg || "Error occurred!!");
        } else {
          this.setState(this.initialState);
          this.props.history.push("ScanList");
        }
      })
      .catch((err) => {
        alert("Error occurred!!");
      })
      .finally(() => {
        this.setState({ toggle_finish_btn_loader: false });
      });
  };

  // updatePartDetail = () => {
  //   var imageEditorCanvas = document.getElementsByClassName("lower-canvas");
  //   var base64image = imageEditorCanvas[0].toDataURL("image/jpeg", 1.0);
  //   // Validation here 
  //     this.setState({ toggle_update_btn_loader: true });
  //     const dentsData  = this.state.data.Dents
  //     let index 
  //     let updatePart = dentsData.filter( (item,i) =>{
  //       if(item.Part === this.state.prePopulatePartName){
  //         index = i
  //       }
  //       return item.Part === this.state.prePopulatePartName
  //     })
  //     // let indexOfPart = dentsData.findIndex((element) => {
  //     //   return element.Part === this.state.prePopulatePartName
  //     // });
  //     updatePart[0].A = parseInt(this.state.A)
  //     updatePart[0].Size_of_damage_A = this.state.Size_of_damage_A
  //     updatePart[0].B = parseInt(this.state.B)
  //     updatePart[0].Size_of_damage_B = this.state.Size_of_damage_B
  //     updatePart[0].C = parseInt(this.state.C)
  //     updatePart[0].Size_of_damage_C = this.state.Size_of_damage_C
  //     updatePart[0].Comment = this.state.prepopulateComment
  //     updatePart[0].TotalDents = (parseInt(this.state.A) + parseInt(this.state.B) + parseInt(this.state.C))
  //     dentsData[index] = updatePart[0]
  //     const finalPostData = this.state.data
  //     finalPostData.Dents = dentsData
  //     const url =
  //     configuration.PostEditorChanges +
  //     `?partnerId=${localStorage.getItem(
  //       "partnerId"
  //     )}&vin=${localStorage.getItem("selectedFile")}&dents=${updatePart[0].TotalDents}`;

  //     let ImageUploadData = JSON.stringify({
  //       partnerId : localStorage.getItem("partnerId"),
  //       vin: localStorage.getItem("selectedFile"),
  //       base64image,
  //       imageName: this.props.staticImageUrl
  //     })

  //     Axios.post(url, finalPostData).then((res) => {
  //       Axios.post(configuration.updateBase64, ImageUploadData).then((res) => {
  //         if(res.data.success){
  //           Toast.fire({
  //             type: "success",
  //             title: "Data saved successfully",
  //           });
  //         }
  //       })
  //     })
  //     .catch(error => {
  //       if(error.response.status === 404){
  //         alert('File does not exist. File could not be replaced.')
  //       } else {
  //         alert('Something went wrong please try again later')
  //       }
  //     })
  //     .finally(() => {
  //       this.setState({ toggle_update_btn_loader: false });
  //     });
  // };

  render() {
    const {
      type_of_damage,
      size_of_damage,
      comment,
      damage_part_name,
    } = this.state;
    let normalFormView = (
      <div className="row mt-4 p-0">
          <div className="col-lg-4">
            <FormGroup>
              <Label>Type Of Damage</Label>
              <div className="dropdown mt-1">
                <select
                  name="type_of_damage"
                  className="form-control p-2"
                  onChange={this.handleChange}
                  value={type_of_damage}
                >
                  {[
                    { title: "Select", value: "" },
                    { title: "Scratch", value: "Scratch" },
                    {
                      title: "Paint",
                      value: "Paint",
                    },
                    {
                      title: "Dent",
                      value: "Dent",
                    },
                    {
                      title: "Bump",
                      value: "Bump",
                    },
                    { title: "Other Damage", value: "Other Damage" },
                  ].map((row, ind) => (
                    <option key={ind}> {row.title}</option>
                  ))}
                </select>
              </div>
            </FormGroup>
          </div>
          <div className="col-lg-4">
            <FormGroup>
              <Label>Size Of Damage</Label>
              <div className="dropdown mt-1">
                <select
                  name="size_of_damage"
                  className="form-control p-2"
                  onChange={this.handleChange}
                  value={size_of_damage}
                >
                  {[
                    { title: "Select", value: "" },
                    { title: "0 - 3 mm", value: "0 - 3 mm" },
                    {
                      title: "3 - 15 mm",
                      value: "3 - 15 mm",
                    },
                    {
                      title: "15 mm and above",
                      value: "15 mm and above",
                    },
                  ].map((row, ind) => (
                    <option key={ind}> {row.title}</option>
                  ))}
                </select>
              </div>
            </FormGroup>
          </div>
          <div className="col-lg-4">
            <FormGroup>
              <Label>Part Of Damage</Label>
              <div className="dropdown mt-1">
                <select
                  name="damage_part_name"
                  className="form-control p-2"
                  onChange={this.handleChange}
                  value={damage_part_name}
                >
                  {[
                    { title: "Select", value: "" },
                    { title: "Hood", value: "Hood" },
                    {
                      title: "LeftFrontFender",
                      value: "LeftFrontFender",
                    },
                    {
                      title: "LeftFrontDoor",
                      value: "LeftFrontDoor",
                    },
                    {
                      title: "LeftBackDoor",
                      value: "LeftBackDoor",
                    },
                    { title: "LeftBackFender", value: "LeftBackFender" },
                    {
                      title: "Trunk",
                      value: "Trunk",
                    },
                    {
                      title: "Trunk Cover",
                      value: "Trunk Cover",
                    },
                    {
                      title: "RightBackFender",
                      value: "RightBackFender",
                    },
                    {
                      title: "RightBackDoor",
                      value: "RightBackDoor",
                    },
                    { title: "RightFrontDoor", value: "RightFrontDoor" },
                    {
                      title: "RightFrontFender",
                      value: "RightFrontFender",
                    },
                    {
                      title: "Roof",
                      value: "Roof",
                    },
                    {
                      title: "LeftRoofFrame",
                      value: "LeftRoofFrame",
                    },
                    {
                      title: "RightRoofFrame",
                      value: "RightRoofFrame",
                    },
                  ].map((row, ind) => (
                    <option key={ind}> {row.title}</option>
                  ))}
                </select>
              </div>
            </FormGroup>
          </div>
          <div className="col-lg-12">
            <FormGroup>
              <Label for="exampleText">Comment</Label>
              <Input
                type="textarea"
                name="comment"
                className="mt-1"
                onChange={this.handleChange}
                value={comment}
              />
            </FormGroup>
          </div>
      </div>
    )

    let prepopulateForm = (
      <div ></div>
    )
    return (
      <Form>
        <div className="container-fluid image_editor_main">
          <div className={this.props.prepopulate ? 'row mt-3 p-0': 'row mt-3'}>
            <div className={this.props.prepopulate ? 'col-12 p-0': 'col-12'} style={{height:"700px"}}>
              {
                (this.state.loading && window.location.pathname !== "/ImageEditor")
                  ? 
                  <RequestLoader size="60px" style={{ marginLeft: "24px" }} /> 
                  :
                  <TuiImageEditor {...this.props}/>
              }
              {this.state.imageLoadingError && <h5>An error occured while loading the image</h5>}
            </div>
            { this.props.prepopulate ? prepopulateForm : normalFormView }
            { this.props.prepopulate ? ''
            :
            <div className="row justify-content-between ml-2 mr-2">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Button onClick={this.onNextClick}>NEXT</Button>
                {this.state.toggle_next_btn_loader && (
                  <RequestLoader size="32px" style={{ marginLeft: "24px" }} />
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {this.state.toggle_finish_btn_loader && (
                  <RequestLoader size="32px" style={{ marginRight: "24px" }} />
                )}
                <Button onClick={this.onFinishClick}>FINISH</Button>
              </div>
            </div>}
          </div>
        </div>
      </Form>
    );
  }
}

class TuiImageEditor extends React.Component {
  rootEl = React.createRef();
  imageEditorInst = null;

  componentDidMount() {
    let normalProperties = {
      includeUI: {
        theme: {
          // "header.display": 'none',
          "menu.normalIcon.color": "#8a8a8a",
          "menu.activeIcon.color": "#555555",
          "menu.disabledIcon.color": "#434343",
          "menu.hoverIcon.color": "#e9e9e9",
          "submenu.normalIcon.color": "#8a8a8a",
          "submenu.activeIcon.color": "#e9e9e9",
        },
        menu: ["shape", "draw", "crop", "rotate", "text"],
        initMenu: "shape",
        uiSize: {
          width: "100%",
          height: "100%",
        },
        menuBarPosition: "bottom",
      },
      cssMaxHeight: 500,
      cssMaxWidth: 700,
      selectionStyle: {
        cornerSize: 20,
        rotatingPointOffset: 70,
      },
      usageStatistics: true,
    }
    let prePopulateProperties = {
      includeUI: {
        loadImage: {
          path: this.props.imageUrl,
          name: 'p-1'
        },
        theme: {
          // "header.display": 'none',
          "menu.normalIcon.color": "#8a8a8a",
          "menu.activeIcon.color": "#555555",
          "menu.disabledIcon.color": "#434343",
          "menu.hoverIcon.color": "#e9e9e9",
          "submenu.normalIcon.color": "#8a8a8a",
          "submenu.activeIcon.color": "#e9e9e9",
        },
        menu: ["shape", "draw", "crop", "rotate", "text"],
        initMenu: "shape",
        uiSize: {
          width: "100%",
          height: "100%",
        },
        menuBarPosition: "bottom",
      },
      cssMaxHeight: 400,
      cssMaxWidth: 700,
      selectionStyle: {
        cornerSize: 20,
        rotatingPointOffset: 70,
      },
      usageStatistics: true,
    }
    this.imageEditorInst = new ToastUiImageEditor(this.rootEl.current,this.props.prepopulate ? prePopulateProperties: normalProperties);
    // this.imageEditorInst = new ToastUiImageEditor(this.rootEl.current, normalProperties);
    document.getElementsByClassName(
      "tui-image-editor-header-logo"
    )[0].style.padding = this.props.prepopulate ? '18px 15px' : '17px'
    document.getElementsByClassName(
      "tui-image-editor-header-logo"
    )[0].childNodes[1].src = this.props.prepopulate ? '': require("../../assets/image-editor.png");
    document.getElementsByClassName(
      "tui-image-editor-header-logo"
    )[0].childNodes[1].style.width = this.props.prepopulate ? '90px' : '135px'
    document.getElementsByClassName(
      "tui-image-editor-header-logo"
    )[0].childNodes[1].style.height = this.props.prepopulate ? '15px' : ''
    document
      .getElementsByClassName("tui-image-editor-controls-buttons")[0]
      .remove();
    document.getElementsByClassName(
      "tui-image-editor-header-buttons"
    )[0].childNodes[1].style.display = `none`;
    document.getElementsByClassName(
      "tui-image-editor-download-btn"
    )[0].style.display = "none";

    const select_img_btn = document.createElement("div");
    select_img_btn.style.cssText = "border: 0;";
    select_img_btn.innerHTML = this.props.prepopulate ? ' ' : `<div id="tui-image-editor-select-image-button" style="background-color: #fff;border: 1px solid #ddd;color: #222;font-family: 'Noto Sans', sans-serif;font-size: 12px ${this.props.prepopulate ? 'width: 20px; font-size: 8px; width: 71px; margin:0.3rem 2.5rem;' : ' '}">Select Image</div>`;
    if(!this.props.prepopulate){
        document
        .getElementsByClassName("tui-image-editor-header-buttons")[0]
        .appendChild(select_img_btn);
        document.getElementById(
          "tui-image-editor-select-image-button"
        ).onclick = () =>
          document.getElementsByClassName("tui-image-editor-load-btn")[0].click();
    }
    var labelChangeRectangle = document.getElementsByClassName('tui-image-editor-button rect')[0].lastElementChild 
    labelChangeRectangle.innerHTML = 'Dent'
    var labelChangeCircle = document.getElementsByClassName('tui-image-editor-button circle')[0].lastElementChild 
    labelChangeCircle.innerHTML = 'Scratch'
    var labelChangeTriangle = document.getElementsByClassName('tui-image-editor-button triangle')[0].lastElementChild 
    labelChangeTriangle.innerHTML = 'Bump'
    document.getElementsByClassName(
      "tui-image-editor-help-menu"
    )[0].style.cssText =
      "width: auto; border-radius: 5px; padding: 6px 10px 0 10px;";

    if(!this.props.prepopulate){
      const list_item_download_button = document.createElement("li");
    list_item_download_button.classList = "tui-image-editor-item help";
    list_item_download_button.setAttribute("tooltip-content", "Download Image");
    list_item_download_button.setAttribute("id", "tui-image-item-download-btn");
    list_item_download_button.innerHTML = `<img src=${require("../../assets/download_image.png")} style="height: 24px;" />`;
    document
      .getElementsByClassName("tui-image-editor-help-menu")[0]
      .appendChild(list_item_download_button); 
      document.getElementById("tui-image-item-download-btn").onclick = () =>
      document
        .getElementsByClassName("tui-image-editor-download-btn")[0]
        .click();
    }
    if(this.props.prepopulate){
      document.getElementsByClassName("tui-image-editor-header-logo")[0].remove()
    }  
    document.getElementsByClassName("tui-image-editor-item")[3].remove();
    document.getElementsByClassName("tui-image-editor-item")[7].remove();
  }

  componentWillUnmount() {
    this.imageEditorInst.destroy();
    this.imageEditorInst = null;
  }

  getInstance() {
    return this.imageEditorInst;
  }

  getRootElement() {
    return this.rootEl.current;
  }

  render() {
    return <div className="rounded" ref={this.rootEl} />;
  }
}

export default ImageEditor;
